import { render, staticRenderFns } from "./ImprimirTicket.vue?vue&type=template&id=2b01d9c5&scoped=true&"
import script from "./ImprimirTicket.vue?vue&type=script&lang=js&"
export * from "./ImprimirTicket.vue?vue&type=script&lang=js&"
import style0 from "./ImprimirTicket.vue?vue&type=style&index=0&id=2b01d9c5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b01d9c5",
  null
  
)

export default component.exports